import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint2 } from './parts/sideParts'
import { verticalPartsOfWeb, verticalPartsOfWebWithCenterStitch } from './parts/verticalParts'
import { drawWithImagePattern, drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const crossWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  await verticalPartsOfWeb(ctx, webColor2 || webColor, stitchColor, printLeatherTypeValue)
  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ_横＿中間
  await middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10, printLeatherTypeValue)
}

export const crossWebCenterStitch = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  await verticalPartsOfWebWithCenterStitch(ctx, webColor2 || webColor, stitchColor, printLeatherTypeValue)
  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ_横＿中間
  await middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10, printLeatherTypeValue)
}

export const crossJointWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  await verticalPartsOfWeb(ctx, webColor, stitchColor, printLeatherTypeValue)

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(259, 204) // 上
  ctx.quadraticCurveTo(281, 276, 314, 339) // 下
  // 縦＿右
  ctx.moveTo(286, 166) // 上
  ctx.quadraticCurveTo(300, 238, 332, 305) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ先端
  const drawWebTip = () => {
    ctx.lineWidth = 0.8
    ctx.beginPath()
    ctx.moveTo(242, 277) // 左上
    ctx.quadraticCurveTo(252, 291, 250, 290) // 左下
    ctx.quadraticCurveTo(275, 180, 368, 135) // 右下
    ctx.quadraticCurveTo(356, 122, 356, 122) // 右上
    ctx.quadraticCurveTo(258, 175, 242, 277) // 右上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const webTipColor = webColor2 || webColor
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawWebTip, webTipColor)

  ctx.strokeStyle = '#282828'
  ctx.beginPath()
  ctx.moveTo(250, 290) // 左下
  ctx.quadraticCurveTo(275, 180, 368, 135) // 右下
  ctx.stroke()
  ctx.closePath()

  await topSidePartOfWebWithJoint2(ctx, webColor, webColor2 || webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ_横＿中間
  await middleSidePartOfWeb(ctx, webColor2 || webColor, stitchColor, 17, 32, printLeatherTypeValue)
}
